import angular from 'angular';
import { AccountConstantsModule } from '@buildium/angularjs-core/dist/constants/account';
import { EsignaturesAccountApi } from './esignatures-account-api';
import { EsignaturesAccountService } from './esignatures-account.service';
import { SettingsServiceModule } from '../../../../../settings/settings.module';

export const EsignaturesAccountApiModule = angular.module('buildium.manager.leases.esignatures.services.esignaturesAccountApi', [])
    .service('EsignaturesAccountApi', EsignaturesAccountApi);

export const EsignaturesAccountServiceModule = angular.module('buildium.manager.leases.esignatures.services.esignaturesAccountService', [
    AccountConstantsModule.name,
    EsignaturesAccountApiModule.name,
    SettingsServiceModule.name
])
    .service('EsignaturesAccountService', EsignaturesAccountService);
